import React from 'react';

const SpinLoader = ({
  size = 32,
  color = '#528ac1',
  containerHeight,
}: {
  size?: number;
  color?: string;
  containerHeight?: string;
}) => (
  <div
    style={{
      display: 'flex',
      width: '100%',
      height: containerHeight,
      alignItems: 'center',
      justifyContent: 'center',
    }}
    className="spin-wrapper"
  >
    <div
      data-testid="tail-spin-loading"
      aria-label="tail-spin-loading"
      aria-busy="true"
      role="progressbar"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 38 38"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="tail-spin-svg"
      >
        <defs>
          <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
            <stop stopColor="#528ac1" stopOpacity="0" offset="0%" />
            <stop stopColor="#528ac1" stopOpacity=".631" offset="63.146%" />
            <stop stopColor="#528ac1" offset="100%" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(1 1)">
            <path
              d="M36 18c0-9.94-8.06-18-18-18"
              id="Oval-2"
              stroke={color}
              strokeWidth="2"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite"
              />
            </path>
            <circle
              fill="#fff"
              cx="36"
              cy="18"
              r="1"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </g>
      </svg>
    </div>
  </div>
);

export default SpinLoader;
